import React from 'react'

interface Props {
    toggleCoverActive: (params: boolean) => void
    send: (msg: string, payload: string, options?: object) => void
    coverOptions: any
    dataset: any
}

export const AscCoverPage: React.FC<Props> = ({ toggleCoverActive, dataset, coverOptions, send }: Props) => {
    const {
        cover_page_background_color,
        cover_page_text_color,
        cover_page_start_btn_color,
        cover_page_start_btn_text_color,
        cover_page_hyperlink_color,
        big_bot_avatar_url,
        terms_link,
        initial_contentful_id,
        sponsor_enabled,
        default_sponsor_logo,
        default_sponsor_cover_page_text,
        sponsor_logo,
        sponsor_cover_page_text,
        find_out_more_url,
    } = dataset

    const { options } = coverOptions

    const coverPageTitle = sessionStorage.getItem('custom_cover_page_title')
    const coverPageText = sessionStorage.getItem('custom_cover_page_text')
    const coverPageButtonText = sessionStorage.getItem('custom_cover_page_btn_text')

    const onSubmit = () => {
        const messageAndPayload = initial_contentful_id && initial_contentful_id.length > 0 ? initial_contentful_id : options.split('||')[0]
        toggleCoverActive(false)
        send(messageAndPayload, '/submitCoverpage', { clearKeywords: true, clearNextPayload: true })
    }

    return (
        <div
            className='coverPageHolder'
            style={{
                width: 'calc(100% - 30px)',
                height: `calc(100% - 60px)`,
                color: cover_page_text_color,
                backgroundColor: cover_page_background_color,
            }}
        >
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <div className='coverPageImgHolder'>
                    <img
                        src={big_bot_avatar_url}
                        className='coverPageImg'
                        alt='chatbot logo'
                        style={{ borderRadius: '100%', height: '100px' }}
                    />
                </div>
                {sponsor_enabled && (
                    <div className='sponsorImgHolder'>
                        <img
                            src={sponsor_logo ? sponsor_logo : default_sponsor_logo}
                            className='testImg'
                            style={{ borderRadius: '100%', height: '90px' }}
                            alt='sponsor logo'
                        />
                    </div>
                )}
            </div>
            {coverPageTitle && <b className='coverPageHeader'>{coverPageTitle}</b>}
            {coverPageTitle && sponsor_enabled && (
                <b className='coverPageHeader'>{sponsor_cover_page_text ? sponsor_cover_page_text : default_sponsor_cover_page_text}</b>
            )}

            {coverPageText && <div className='coverPageText'>{coverPageText}</div>}
            {find_out_more_url && (
                <div className='coverPageText'>
                    Find out more about me
                    <a
                        style={{ color: cover_page_hyperlink_color, display: 'inline', paddingLeft: '4px' }}
                        href={find_out_more_url}
                        target='_blank'
                        rel='noreferrer'
                    >
                        here
                    </a>
                    .
                </div>
            )}
            <div className='coverPageButtonContainer'>
                <button
                    onClick={() => onSubmit()}
                    className='coverPageSubmitButton'
                    style={{ color: cover_page_start_btn_text_color, backgroundColor: cover_page_start_btn_color }}
                >
                    {coverPageButtonText ? coverPageButtonText : 'Get Started'}
                </button>
            </div>
        </div>
    )
}
